// extracted by mini-css-extract-plugin
export default {"editCredentialsPopup":"CallCenterLoginPopup_editCredentialsPopup__tLvY1","textbox":"CallCenterLoginPopup_textbox__vP8wc","errorMessage":"CallCenterLoginPopup_errorMessage__0r41i"};